// Environment configuration - change this to 'dev' or 'prod'
const environment = 'prod';


export const ENVIRONMENT = environment as 'dev' | 'prod';
export const DEV_MODE = ENVIRONMENT === 'dev';

export const API_CONFIG = {
  BASE_URL: `https://0l3uy0laok.execute-api.eu-west-1.amazonaws.com/${ENVIRONMENT}/api`,
  COGNITO_URL: 'https://cognito-idp.eu-west-1.amazonaws.com',
  LAMBDA_BASE_URL: `https://0l3uy0laok.execute-api.eu-west-1.amazonaws.com/${ENVIRONMENT}/api`,
  TIMEOUT: 10000,
  HEADERS: {
    'Content-Type': 'application/json',
  }
};

export const AMPLIFY_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: ENVIRONMENT === 'dev' ? 'eu-west-1_RfqtkXocf' : 'eu-west-1_ZCwYqPzau',
      userPoolClientId: ENVIRONMENT === 'dev' ? '49q0hpicii14gj0f6avqm9emks' : '67j5aarrc5eu7p65n95u5snija',
      loginWith: {
        email: true,
      },
    },
  },
};

export const VEHICLE_TRACKING_CONFIG = {
  DEVICE_POLLING_INTERVAL: 300000, // 5 minutes in milliseconds
  DEMO_BUS_UPDATE_INTERVAL: 300000, // 5 minutes - WebSocket handles real-time, this is just a safety net
};

export const SUPERSET_CONFIG = {
  URL: 'https://reporting.golearn.fuseit.co.za/superset/welcome/',
  DASHBOARD_DEPARTMENT_REPORTS: '619ff355-ea92-4fdf-b157-f521efa70829',
  LAMBDA_URL: 'https://yzvdb3brfxbygo7zy36mq5q6zm0enxlj.lambda-url.eu-west-1.on.aws/'
};


